export const PORTFOLIO_STATUS = [
  {
    name: 'Tất cả',
    values: 99,
  },
  {
    name: 'Mới tạo',
    values: 0,
  },
  {
    name: 'Chờ phê duyệt',
    values: 1,
  },
  {
    name: 'Đã phát hành',
    values: 2,
  },
  {
    name: 'Hết hạn',
    values: 3,
  },
];
